import { Component, forwardRef } from '@angular/core';
import { ModifierListAbstract } from '../modifier-list.abstract';
import { FormArray, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormModifierItem, ModifierItem } from '../modifier-item.interface';
import { ItemModifier } from 'src/app/api/v1/models';

@Component({
  selector: 'app-single-modifiers',
  templateUrl: './single-modifiers.component.html',
  styleUrls: ['./single-modifiers.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SingleModifiersComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SingleModifiersComponent),
      multi: true,
    }
  ]
})
export class SingleModifiersComponent extends ModifierListAbstract<ModifierItem> {
  constructor() {
    super();
  }

  isOverflow: boolean = false;
  formArray = new FormArray<FormGroup<FormModifierItem>>([]);

  onChangeCount(): void {
    this.isOverflow = this.isCheckOverflow();
    this.update();
  }

  override writeFormValue(formData: ModifierItem[]): void {
    if (!this.form.contains('modifiers')) {
      formData.forEach(item => {
        const group = this.getFormItem();
        group.patchValue(item);
        this.formArray.push(group);
      });
      this.form.addControl('modifiers', this.formArray);
    } else if (this.form.controls['modifiers'].value.length === formData.length) {
      this.form.controls['modifiers'].setValue(formData);
    }
  }

  override getFormData(): ModifierItem[] | null {
    return this.formArray.getRawValue().length ? this.formArray.getRawValue() : null;
  }

  private isCheckOverflow(): boolean {
    if (this.maxCount === 0) {
      return false;
    }
    let totalCount = 0;

    this.formArray.getRawValue().forEach(value => {
      totalCount += value.quantity;
    });

    return totalCount >= this.maxCount;
  }

  isFree(item: ItemModifier, freeQuantity: number) {
    const groupFreeQuantity = this.modifierGroup.restrictions.freeQuantity;
    const currentFreeQuantity = this.formArray.getRawValue().reduce((total, value) => total += value.freeQuantity, 0);

    return this.isCheckMinMaxRestrictions
      ? freeQuantity < item.restrictions.freeQuantity && currentFreeQuantity < groupFreeQuantity
      : currentFreeQuantity < groupFreeQuantity;
  }
}
